<template>
  <div class="text-center">
    <img src="@/assets/logo.jpg" width="100px" style="margin:50% 0 10% 0">
    <van-loading color="#1989fa"/>
  </div>
</template>

<script>
import Api from '@/utils/api'
export default {
  created () {
    let code = this.$route.query.code
    let state = this.$route.query.state
    let uri = this.$route.query.uri === undefined ? '/' : this.$route.query.uri
    if (uri === '') uri = '/'
    if (uri === '/') uri += this.$route.query.is_authorize !== undefined ? '?is_authorize=1' : ''

    // debug
    // if (process.env.NODE_ENV === 'development') {
    //   this.$store.dispatch('permission/setToken', 'a47b214c0d4911ed9cdc2a9f9f41653a')
    //   this.$router.push({path: '/'})
    //   return false
    // }

    if (code !== undefined) {
      if (state !== 'tbx') return false
      Api.post('wei.user/mpCode2WeiUser', {code: code}, res => {
        this.$store.dispatch('permission/setToken', res.data.token)
          .then(() => {
            // Api.post('cus.user/weixin', null, () => {
            //   this.$router.push({path: uri})
            // }, () => {
            //   this.$router.push({path: '/bind?uri=' + uri})
            // })
            this.$router.push({path: '/success'})
          })
      }, () => this.$router.push({path: '/passport'}))
    } else {
      let url = 'https://open.weixin.qq.com/connect/oauth2/authorize'
      url += '?appid=wx75f95db1e5ed82cf'
      url += '&redirect_uri=' + encodeURIComponent('https://wx.tbxprint.com/passport?is_authorize=1&uri=' + uri)
      url += '&response_type=code'
      // url += '&scope=snsapi_base' // 获取基本信息
      url += '&scope=snsapi_userinfo' // 获取详细信息
      url += '&state=tbx'
      url += '#wechat_redirect'
      window.location.href = url
    }
  },
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Passport.vue